import { useEffect, useState } from "react";
import MarkdownIt from "markdown-it";

import { Layout } from "../../../components";
import { getPages } from "../api";


const ShippingPolicy = () => {

  const [privacyPolicy, setPrivacyPolicy] = useState<string>('');


  const mdParser = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
  });

  useEffect(() => {
    getPages({ type: 8 }).then((res: any) => {
      setPrivacyPolicy(res.data.data.content);
    });
    window.scrollTo(0, 0);
  }, [])

  return (
    <Layout>
      <div className="container">
        <h3 className="text-center mt-5 mb-3">Shipping Policy </h3>
        <div
          // className="mb-5"
          // dangerouslySetInnerHTML={{
          //   __html: mdParser.render(privacyPolicy),
          // }}
        />
       <h1>Shipping Policy</h1>

<p>
  TravelX eSIMs and services reach customers in over 200 countries. As it is an eSIM solution, shipping is not required. We will send QR codes through different modes of communication so that customers can scan and activate the cards. However, if we use physical shipping, please see the details below for a brief overview.
</p>

<h2>Shipping Methods</h2>
<p>We offer the following shipping methods to cater to your needs:</p>
<ul>
  <li><strong>Standard Shipping:</strong> Reliable and economical.</li>
  <li><strong>Express Shipping:</strong> Fast and efficient for urgent requirements.</li>
  <li><strong>International Shipping:</strong> Comprehensive coverage for global destinations.</li>
</ul>

<h2>Delivery Time</h2>
<ul>
  <li><strong>Standard Shipping:</strong> Estimated delivery time is 5-7 business days.</li>
  <li><strong>Express Shipping:</strong> Estimated delivery time is 2-3 business days.</li>
  <li><strong>International Shipping:</strong> Estimated delivery time varies by destination, typically between 7-14 business days.</li>
</ul>

<h2>Order Processing Time</h2>
<p>All orders are processed within 1-2 business days. Orders are not shipped or delivered on weekends or holidays.</p>

<h2>Tracking</h2>
<p>
  Once your order is shipped, you will receive a shipping confirmation email with a tracking number. You can use this number to track the status of your shipment through our carrier’s website.
</p>

<h2>Lost or Damaged Items</h2>
<p>
  If your order is lost or arrives damaged, please get in touch with our customer service team at <a href="mailto:support@travelx.ai">support@travelx.ai</a> within 7 days of receiving your order. We will assist you in filing a claim with the shipping carrier and arrange for a replacement or refund as necessary.
</p>

<h2>Returns</h2>
<p>
  If you encounter any issues related to shipping, such as incorrect items received, please contact our customer service team at <a href="mailto:support@travelx.ai">support@travelx.ai</a> within 14 days of receiving your order. We will provide instructions for returning the items and arrange for a replacement or refund as appropriate.
</p>

<h2>Additional Information</h2>
<p>
  For any additional information regarding our shipping policy, please feel free to reach out to our customer service team at <a href="mailto:support@travelx.ai">support@travelx.ai</a>. We are here to help and ensure your satisfaction with TravelX.
</p>
      </div>
    </Layout>
  );
};

export default ShippingPolicy;